import React, { useEffect, useState } from 'react';
import './AinurPOS.scss';
import '../../styles/caseStyles.scss';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import questionsImg from '../../assets/images/ainurpos__questions.png';
import auditImg from '../../assets/images/ainurpos__audit.png';
import ImageSlider from '../../components/ImageSlider/ImageSlider';
import chalengeCoverImg from '../../assets/images/ainurpos__chalenge-cover.png';
import architectureImg from '../../assets/images/ainurpos__architecture.png';
import wireframesImg from '../../assets/images/ainurpos__wireframes.png';
import mockupWithBlueBgImg from '../../assets/images/ainurpos__mockup-with-blue-bg.png';
import flow1Img from '../../assets/images/ainurpos__flow1.png';
import flow2Img from '../../assets/images/ainurpos__flow2.png';
import flow3Img from '../../assets/images/ainurpos__flow3.png';
import flow4Img from '../../assets/images/ainurpos__flow4.png';
import flow5Img from '../../assets/images/ainurpos__flow5.png';
import outcomesImg from '../../assets/images/ainurpos__outcomesImg.png';
import coverImg from '../../assets/images/ainurpos__cover.png';
import screenAndStorageImg from '../../assets/images/ainurpos__screen-and-storage.png';
import cashRegisterImg from '../../assets/images/ainurpos__cash-register.png';
import questionsMobImg from '../../assets/images/ainurpos__questions-mob.png';
import FadeInSection from '../../components/FadeInSection';

import {
  colorsSlideData,
  colorsSolutionSlideData,
  exchangeSlideData,
  exchangeSolutionSlideData,
  extraActionsSlideData,
  favoriteItemsSolutionSlideData,
  identifyingAndWorkspaceSlideData,
  identifyingSolutionSlideData,
  lessClickSolutionSlideData,
  lockSolutionSlideData,
  paymentSlideData,
  paymentSolutionSlideData,
  printerSlideData,
  recieptsSolutionSlideData,
  sortingSlideData,
} from '../../constants/ainurSlideData';
import Slide from '../../components/Slide/Slide';
import SkeletonPage from '../../components/SkeletonPage/SkeletonPage';

const slidesArr = [
  <Slide key={exchangeSlideData.title} {...exchangeSlideData} />,
  <Slide key={paymentSlideData.title} {...paymentSlideData} />,
  <Slide key={identifyingAndWorkspaceSlideData.title} {...identifyingAndWorkspaceSlideData} />,
  <Slide key={sortingSlideData.title} {...sortingSlideData} />,
  <Slide key={extraActionsSlideData.title} {...extraActionsSlideData} />,
  <Slide key={printerSlideData.title} {...printerSlideData} />,
  <Slide key={colorsSlideData.title} {...colorsSlideData} />,
];

const sliderSolutionsArr = [
  <Slide key={exchangeSolutionSlideData.title} {...exchangeSolutionSlideData} />,
  <Slide key={paymentSolutionSlideData.title} {...paymentSolutionSlideData} />,
  <Slide key={identifyingSolutionSlideData.title} {...identifyingSolutionSlideData} />,
  <Slide key={lockSolutionSlideData.title} {...lockSolutionSlideData} />,
  <Slide key={favoriteItemsSolutionSlideData.title} {...favoriteItemsSolutionSlideData} />,
  <Slide key={lessClickSolutionSlideData.title} {...lessClickSolutionSlideData} />,
  <Slide key={recieptsSolutionSlideData.title} {...recieptsSolutionSlideData} />,
  <Slide key={colorsSolutionSlideData.title} {...colorsSolutionSlideData} />,
];

const AinurPOS = (props) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    // Создаем объект Image для предварительной загрузки
    const img = new Image();
    img.src = coverImg; // Укажите URL изображения

    // Устанавливаем слушатель загрузки для обновления состояния
    img.onload = () => {
      setIsImageLoaded(true);
    };

    // Обработка ошибки (если изображение не загружается)
    img.onerror = () => {
      console.error('Ошибка загрузки изображения');
      setIsImageLoaded(true); // Загрузить страницу, даже если изображение не загрузилось
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {!isImageLoaded && <SkeletonPage />}
      {isImageLoaded && (
        <section className="ainurpos case">
          <ProgressBar />
          <FadeInSection>
            <h1 className="case__title">
              AinurPOS is one-stop cloud based platform: e-comm, warehouse, online POS, sales,
              deliveries, employee and roles management, discounts, loyalty and customer CRM. It is 
              <span className="case__title-span">a complex system for small & medium retail</span>
            </h1>{' '}
          </FadeInSection>
          <div className="case__content">
            <FadeInSection>
              <img className="case__content-image" src={coverImg} alt="screen" />
            </FadeInSection>
            {/* <animated.img
          className="case__content-image"
          src={coverImg}
          alt="screen"
          style={parallaxStyle}
        /> */}
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Product</h3>
                  <p>
                    The existing POS system has been in use for several years and is convenient for
                    cashiers, salespeople, warehouse employees and business owners, meeting most of
                    their needs. However,{' '}
                    <span>
                      the system is outdated and does not meet all modern product requirements
                    </span>
                  </p>{' '}
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">My role</h3>
                  <p>
                    I completed all the work: research, interviews, ideating, wireframing,
                    prototyping, user testing, UX, and UI design, independently
                  </p>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                {/* <animated.img
              className="text-and-image__single-img"
              src={screenWidth <= 853 ? cashRegisterImg : screenAndStorageImg}
              alt="screen"
              style={parallaxStyle}
            /> */}
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth <= 853 ? cashRegisterImg : screenAndStorageImg}
                    alt="screen with app"
                  />
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title case__short-title">
                How can I upgrade the system to{' '}
                <span className="case__title-span">meet modern requirements?</span>
              </h2>
            </FadeInSection>
            <div className="text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Research</h3>
                  <div>
                    <p>
                      I started working with research to understand exactly what shortcomings and
                      opportunities for growth we have and what pain points exist for current users
                    </p>
                    <p>
                      I decided to <span>interview</span> target audience representatives, create{' '}
                      <span>user personas,</span> and{' '}
                      <span>analyze current and competitor solutions</span> to identify existing
                      problems
                    </p>
                  </div>
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Interview</h3>
                  <div>
                    <p>
                      I found 12 people (business owners and employees: cashiers, salespeople and
                      administrators) in order to understand their goals and objectives, joys and
                      disappointments when working with our and competitive systems.
                    </p>
                    <p>
                      I conducted{' '}
                      <span>
                        mix of in-depth interview with demonstration of the current interface.
                      </span>
                      For example, my interview with a former Inditex employee gave me a great
                      insight into the "pains" of a key user
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={screenWidth <= 853 ? questionsMobImg : questionsImg}
                    alt="questions"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Current design audit</h3>
                  <div>
                    <p>
                      After conducting the interview, I began auditing the current application and
                      searching for ideas to improve it. I focused on identifying user pain points
                      directly within the interface
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={auditImg} alt="audit" />
                </FadeInSection>
              </div>
            </div>
            <div className="ainurpos__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">User personas</h3>
                  <div>
                    <p>
                      Unfortunately, we cannot fully focus on each individual consumer to drive the
                      product. That's why I created user personas for us, which enable us to
                      humanize the design and development process
                    </p>
                  </div>{' '}
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Problems</h3>
                  <div>
                    <p>
                      As a result of my research, I identified 8 main problems. Scroll through the
                      carousel to get acquainted with all of them.
                    </p>
                    <p>
                      These problems{' '}
                      <span>make the system less convenient and understandable for users</span>
                    </p>
                  </div>
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <ImageSlider slidesArr={slidesArr} />
            </FadeInSection>
            <FadeInSection>
              <h2 className="case__title case__short-title ainurpos__case-title">
                How can I solve the detected problems and make the existing system{' '}
                <span className="case__title-span">more convenient and understandable</span>{' '}
                for users? <span className="ainurpos__title-description">Challenge</span>
              </h2>{' '}
            </FadeInSection>
            <div className="case__text-and-image text-and-image">
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={chalengeCoverImg}
                    alt="chalenge"
                  />{' '}
                </FadeInSection>
              </div>
            </div>
            <div className="text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Ideation</h3>
                  <div>
                    <p>
                      As always, the work process begins with ideation. For each idea, I wrote down
                      several possible solutions and conducted early testing to choose a single
                      solution
                    </p>
                  </div>{' '}
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Decision</h3>
                  <div>
                    <p>
                      As ideation progressed, it became evident that the system required more
                      comprehensive changes, and the decision was made{' '}
                      <span>to rebrand the current application</span>
                    </p>
                  </div>
                </FadeInSection>
                <FadeInSection>
                  <h3 className="text-and-image__title">Information architecture</h3>
                  <div>
                    <p>
                      Before starting work on solving problems, it is important to understand and
                      build a new information architecture. New sections are highlighted in color
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={architectureImg} alt="audit" />
                </FadeInSection>
              </div>
            </div>
            <div className="text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Wireframes</h3>
                  <div>
                    <p>I have created 20+ wireframes to reflect changes made to the system.</p>
                    <p>
                      Wireframes were developed to represent the user flows and interactions, and a
                      high-fidelity interactive prototype was created to test and validate the
                      solution. During testing, points for improvement were identified
                    </p>
                  </div>
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={wireframesImg} alt="audit" />
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <h2 className="case__title">
                Based on the results of respondents' research, I{' '}
                <span className="case__title-span">
                  made the system more convenient and understandable
                </span>{' '}
                for users and solved the previously identified problems
              </h2>
            </FadeInSection>
            <div className="text-and-image">
              <div className="text-and-image__image">
                <FadeInSection>
                  <img
                    className="text-and-image__single-img"
                    src={mockupWithBlueBgImg}
                    alt="chalenge"
                  />
                </FadeInSection>
              </div>
            </div>
            <div className="ainurpos__text-and-image text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Solution</h3>
                  <div>
                    <p>
                      Here I showed how the problems found were solved and what the impact of their
                      solution will be
                    </p>
                  </div>
                </FadeInSection>
              </div>
            </div>
            <FadeInSection>
              <ImageSlider slidesArr={sliderSolutionsArr} />
            </FadeInSection>
            <div className="text-and-image text-and-image_mob-gap">
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={flow1Img} alt="flow1" />
                </FadeInSection>
              </div>
              <div className="text-and-image__image text-and-image__image-with-streight-corners">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={flow2Img} alt="flow2" />
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={flow3Img} alt="flow3" />
                </FadeInSection>
              </div>
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={flow4Img} alt="flow4" />
                </FadeInSection>
              </div>
              <div className="text-and-image__image text-and-image__image-with-streight-corners">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={flow5Img} alt="flow5" />
                </FadeInSection>
              </div>
            </div>
            <div className="text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Results</h3>
                  <div>
                    <p>
                      It is estimated that the exchange process will reduce the time by half. 30
                      percent less cash register paper will be used
                    </p>
                    <p>
                      <span>The system became more convenient both</span> for users (cashiers and
                      for their consumers (clients of their businesses)
                    </p>
                  </div>{' '}
                </FadeInSection>
                <div></div>
              </div>
            </div>
            <div className="text-and-image">
              <div className="text-and-image__image">
                <FadeInSection>
                  <img className="text-and-image__single-img" src={outcomesImg} alt="flow1" />
                </FadeInSection>
              </div>
            </div>
            <div className="text-and-image">
              <div className="text-and-image__paragraph">
                <FadeInSection>
                  <h3 className="text-and-image__title">Outcomes</h3>
                  <div>
                    <p>
                      After going through the entire design process, I was able to identify user
                      pain points and find a solution for each of them
                    </p>
                    <p>
                      I successfully managed to make the system more understandable and
                      user-friendly
                    </p>
                    <p>
                      11 out of 12 users surveyed felt that the{' '}
                      <span>new design solved their previously identified problems</span>
                    </p>
                  </div>{' '}
                </FadeInSection>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default AinurPOS;
